import { render, staticRenderFns } from "./FacadeEditor.vue?vue&type=template&id=74f742ab"
import script from "./FacadeEditor.vue?vue&type=script&lang=js"
export * from "./FacadeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports